import React,{useState} from 'react';
import {Container, Grid} from '@material-ui/core';
import Banner from '../global/Banner';
import {contactData} from '../../values';
import {useStyles} from '../global/styles';

import {sendMessage} from '../../utils';

export const emailformat = /^([\w.-]+)@([\w-]+)((\.(\w){2,3})+)$/;

const Contact = () => {
    const classes = useStyles()
    const [message, setMessage]     = useState('')
    const [name, setName]           = useState('')
    const [email, setEmail]         = useState('')
    const [flag, setFlag]           = useState(true)
    const send = async() =>{
        if(message && name && email.match(emailformat)){
            setFlag(false)
            const res = await sendMessage(name, email, message)
            console.log(res);
            if(res){
                window.alert('Tu comentario fue enviado exitosamente.')
                setMessage('')
                setName('')
                setEmail('')
            } else{
                window.alert('Al parecer surgio un problema, intentalo más tarde.')
            }
            setFlag(true)
        } else{
            window.alert('Verifica tus datos.')
            console.log("Faltan Datos");
        }
    }
    return (
        <div>
            <Banner title={contactData.title} />
            <div className={classes.containerContact}>
                <Container maxWidth='md'>
                    <div style={{background:'white', paddingTop:20, paddingBottom:20}}>
                        <Grid container>
                            <Grid item xs={12} sm={3}>
                                <Container className={classes.contactLine}>
                                    <p style={{fontSize:38, fontWeight:600, margin:0, fontFamily:'Heavy'}}>{contactData.text1}</p>
                                    <p style={{fontFamily:'Book'}}>{contactData.text2}</p>
                                    <div className={classes.space} />
                                </Container>
                            </Grid>
                            <Grid item xs={12} sm={9}>
                                <div style={{height:15}} />
                                <label className={classes.text1Contact}>{contactData.text3}</label>
                                <div className={classes.containerContactInput}>
                                    <textarea value={message} className={classes.inputArea} onChange={e => setMessage(e.target.value)} />
                                </div>
                                <div className={classes.containerContacForm}>
                                    <Grid container>
                                        <Grid item xs={12} sm={6}>
                                            <label style={{fontFamily:'Book'}}>{contactData.text4}</label>
                                            <input value={name} className={classes.input2} onChange={e => setName(e.target.value)} />
                                        </Grid>
                                        <Grid item xs={12} sm={6}>
                                            <label className={classes.text2Contact} style={{fontFamily:'Book'}}>{contactData.text5}</label>
                                            <input value={email} type='email' className={classes.input1} onChange={e => setEmail(e.target.value)} />
                                        </Grid>
                                    </Grid>
                                </div>
                                <div style={{textAlign:'right', marginRight:25}}>
                                    <button className={classes.button} style={{fontFamily:'Heavy'}} onClick={() => flag ? send() : ''}>
                                        {contactData.button}
                                    </button>
                                </div>
                            </Grid>
                        </Grid>
                    </div>
                </Container>
            </div>
        </div>
    );
};

export default Contact;